import { SortableTableHeader, Table } from 'soprasteria-ui-library';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { formatPersonalSecurityNumberAndOrganisationNumber } from '../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper';
import { IEmergencyTreatmentReport } from "../../../models/IEmergencyTreatment"
import { EMERGENCY_TREATMENT, PATIENT } from '../../../utils/RouteConstants';

interface IEmergencyTreatmentSearchTable {
    emergencyTreatmentReports: IEmergencyTreatmentReport[];
}

export const EmergencyTreatmentSearchTable: React.FunctionComponent<IEmergencyTreatmentSearchTable> = ({ emergencyTreatmentReports }) => {

    const renderTableLink = (linkText: string, emergencyTreatmentId: number, patientGuidId: string) => {
        return <Link to={`${PATIENT}/${patientGuidId}/${EMERGENCY_TREATMENT}/${emergencyTreatmentId}`}>{linkText}</Link>
    }

    return (
        <Table>
            <thead>
                <tr>
                    <SortableTableHeader propertyToSortBy="EmergencyTreatmentDate" headerText="Behandlingsdatum" />
                    <SortableTableHeader propertyToSortBy="EmergencyTreatmentNumber" headerText="Ärendenummer" />
                    <SortableTableHeader propertyToSortBy="Patient.PersonalSecurityId" headerText="Personnummer" />
                    <SortableTableHeader propertyToSortBy="Patient.FirstName" headerText="Namn" />
                    <th>Mottagning</th>
                    <SortableTableHeader propertyToSortBy="EmergencyTreatmentStatus.Description" headerText="Status" />
                </tr>
            </thead>
            <tbody>
                {
                    emergencyTreatmentReports.length > 0 ?
                        emergencyTreatmentReports.map((emergencyTreatmentReport, key) =>
                            <tr key={key} className="clickable-row">
                                <td className="table-data-link">{renderTableLink(dateTimeToDateString(emergencyTreatmentReport.dateOfTreatment), emergencyTreatmentReport.emergencyTreatmentId, emergencyTreatmentReport.patient.patientGuidId)}</td>
                                <td className="table-data-link">{renderTableLink(emergencyTreatmentReport.treatmentNumber, emergencyTreatmentReport.emergencyTreatmentId, emergencyTreatmentReport.patient.patientGuidId)}</td>
                                <td className="table-data-link">{renderTableLink(formatPersonalSecurityNumberAndOrganisationNumber(emergencyTreatmentReport.patient.personalSecurityNumber), emergencyTreatmentReport.emergencyTreatmentId, emergencyTreatmentReport.patient.patientGuidId)}</td>
                                <td className="table-data-link">{renderTableLink(emergencyTreatmentReport.patient.name, emergencyTreatmentReport.emergencyTreatmentId, emergencyTreatmentReport.patient.patientGuidId)}</td>
                                <td className="table-data-link">{renderTableLink(emergencyTreatmentReport.treatingCareProvider.displayCareProviderName ?? "", emergencyTreatmentReport.emergencyTreatmentId, emergencyTreatmentReport.patient.patientGuidId)}</td>
                                <td className="table-data-link">{renderTableLink(emergencyTreatmentReport.status, emergencyTreatmentReport.emergencyTreatmentId, emergencyTreatmentReport.patient.patientGuidId)}</td>
                            </tr>
                        )
                        : <tr><td colSpan={6}>Inga akuträkningar hittades</td></tr>
                }
            </tbody>
        </Table>
    )
}